// @ts-ignore
import type {OutputSelector} from 'reselect';
import type {Source} from '../types';
import {Collections} from '../collections';
import type {CollectionState} from '../collections';

type SourcesModuleState = {
    sources: CollectionState<Source>;
};

/*
 * Given the entire redux state, pull out just the piece of state for the sources reducer.
 */
const getSourcesState = (state: SourcesModuleState) => state.sources;

/*
 * Get an array of all sources models
 */
export const getAll: OutputSelector<any, any, Source[]> =
    Collections.makeGetModels(getSourcesState);

/*
 * Get the `byId` portion of the sources state
 */
export const getById = (state: SourcesModuleState) => {
    const sourcesState = getSourcesState(state);

    return Collections.getById(sourcesState);
};
